export type TrackingDetails = {
  page: string;
  sentBy: string;
};

export type TrackingType = {
  Startpage: TrackingDetails;
  Profile: TrackingDetails;
  Login: TrackingDetails;
};

export const adTrackingParams: TrackingType = {
  Startpage: {
    page: 'welcome/start/index',
    sentBy: 'welcome',
  },
  Login: {
    page: 'welcome/login',
    sentBy: 'welcome',
  },
  Profile: {
    page: 'profile/other/details',
    sentBy: 'profile',
  },
};
